import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';
import PlayerWrapper from 'bdvp-common/src/components/PlaybackWrapper';
import Button from '@mlb/react-patterns/components/Button/button.tsx';

import {
    normalizeMediaItem,
    getShareContentType,
} from 'bdvp-common/src/utils';
import { useMedia } from 'bdvp-common/src/hooks';
import {
    useMediaConfigReel,
    useDictionary,
} from 'bdvp-common/src/hooks/config';
import ShareBtn from 'bdvp-common/src/components/ShareButton';
import { MetadataTwitterButton } from 'bdvp-common/src/components/Metadata';
import { Tracking } from 'bdvp-tracking';

import Wrapper from '../ModalViewWrapper';
import BodyComponent from '../ModalBody';
import FooterComponent from '../ModalFooter';

const Body = styled(BodyComponent)`
    display: flex;
    flex-direction: column;
`;

const Footer = styled(FooterComponent)`
    flex-direction: row;

    ${media.mdmin`
        justify-content: space-between;
    `}
`;

const PlaybackWrapper = styled(PlayerWrapper)`
    width: 100%;
`;

const ShareButton = styled(ShareBtn)`
    margin-right: 12px;
`;

const ViewReelsButton = styled(Button).attrs((({ label, onClick }) => ({
    size: 'md',
    label: label,
    styleName: 'link-blue',
    handlers: {
        onClick,
    },
})))`
    min-width: 174px;
    ${media.mdmin`
        min-width: 120px;
    `}
`;
const BodyShareContainer = styled.div`
    display: block;
    margin-top: 20px;
    text-align: center;
    ${media.mdmin`
        display: none;
    `}
`;

const FooterShareContainer = styled.div`
    display: none;
    ${media.mdmin`
        display: block;
    `}
`;

const Success = (props) => {

    const {
        mediaPlayback,
        lastModalNode,
        userId,
        closeReelCreationModal,
    } = props;

    const {
        view_your_reels: viewYourReels = 'View Your Reels',
    } = useDictionary();
    const {
        player: playerConfig = {},
    } = useMediaConfigReel();

    const isMobile = useMedia([`(min-width: ${BREAKPOINTS.md})`], [false], true);

    const history = useHistory();

    const {
        autoPlay = false,
        initConfig = {},
        mediaConfig = {},
        playerOptions = {},
    } = playerConfig;

    const {
        id: mediaPlaybackId = '',
        slug = '',
        title: mediaPlaybackTitle = '',
    } = mediaPlayback;

    const ShareContainerChildren = (
        <>
            <ShareButton
                mediaId={mediaPlaybackId}
                onClick={() => {

                    Tracking.trackReelCreationShareClick(slug);

                }}
            />
            <MetadataTwitterButton
                {...!isMobile && { twitterButtonRef: lastModalNode }}
                mediaPlayback={mediaPlayback}
                onClick={() => {

                    Tracking.onShare({
                        type: 'Twitter',
                        slug,
                        title: mediaPlaybackTitle,
                        contentType: getShareContentType(mediaPlayback),
                    });

                }}
            />
        </>
    );

    return (
        <Wrapper>
            <Body>
                <PlaybackWrapper
                    playbackContainerId={'reel-player'}
                    autoPlay={autoPlay}
                    initConfig={initConfig}
                    mediaConfig={mediaConfig}
                    playerOptions={{
                        ...playerOptions,
                        metaData: normalizeMediaItem(mediaPlayback),
                    }}
                />
                <BodyShareContainer>
                    {ShareContainerChildren}
                </BodyShareContainer>
            </Body>
            <Footer>
                <ViewReelsButton
                    {...isMobile && { ref: lastModalNode }}
                    label={viewYourReels}
                    onClick={() => {

                        Tracking.trackReelViewYourReelsClick();
                        history.push({ pathname: `/${userId}/reels` });
                        closeReelCreationModal();

                    }}
                />
                <FooterShareContainer>
                    {ShareContainerChildren}
                </FooterShareContainer>
            </Footer>
        </Wrapper>
    );

};

Success.propTypes = {
    mediaPlayback: PropTypes.object.isRequired,
    lastModalNode: PropTypes.object.isRequired,
    closeReelCreationModal: PropTypes.func.isRequired,
};

export default Success;
